/* eslint-disable */
/* tslint:disable */
/* auto-generated vue proxies */
import { defineContainer } from './vue-component-lib/utils';

import type { JSX } from '@ovhcloud/ods-stencil/components/switch/custom-elements';

import { defineCustomElement as defineOsdsSwitch } from '@ovhcloud/ods-stencil/components/switch/custom-elements/osds-switch.js';
import { defineCustomElement as defineOsdsSwitchItem } from '@ovhcloud/ods-stencil/components/switch/custom-elements/osds-switch-item.js';


export const OsdsSwitch = /*@__PURE__*/ defineContainer<JSX.OsdsSwitch>('osds-switch', defineOsdsSwitch, [
  'color',
  'disabled',
  'contrasted',
  'variant',
  'size',
  'odsSwitchChanged'
]);


export const OsdsSwitchItem = /*@__PURE__*/ defineContainer<JSX.OsdsSwitchItem>('osds-switch-item', defineOsdsSwitchItem, [
  'value',
  'checked'
]);

